import React from 'react'
import { Auth } from 'aws-amplify'

const Logout = () => (
    <button type="button" className="dropdown-item" onClick={() => Auth.signOut()}>
        <i className="uil uil-sign-out-alt font-size-18 align-middle mr-1 text-muted"></i>
        <span className="align-middle">Sign out</span>
    </button>
)

export default Logout
